import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SocketService {
  private socket: Socket = io(environment.wsUrl, {
    transports: ['websocket'],
    autoConnect: false,
  });

  constructor() {
    this.socket.on('connect', () => {
      // console.log('ws conectado', this.socket.id);
    });

    this.socket.on('connect_error', (e) => {
      // console.error('ws error:', e.message);
    });
  }

  connect(token: string) {
    if (this.socket.connected) return;
    this.socket.auth = { token };
    this.socket.connect();
  }

  disconnect(): void {
    this.socket.disconnect();
    this.socket.auth = {};
  }

  on<T = unknown>(evento: string): Observable<T> {
    return new Observable<T>((sub) => {
      const handler = (data: T) => sub.next(data);

      this.socket.on(evento, handler);
      return () => this.socket.off(evento, handler);
    });
  }
}
